export const OWNSPACE_INFO = {
  PHONE_NUMBER: "+1 (514) 312-0323",
  ADDRESS: "1176 Sherbrooke Street Ouest, Montreal QC H3A 1H6",
  GENERAL_EMAIL: "info@ownspace.com",
  SUPPORT_EMAIL: "support@ownspace.com",
  PRIVACY_POLICY_PAGE_URL_EN: "https://ownspace.com/en/privacy-policy",
  PRIVACY_POLICY_PAGE_URL_FR: "https://ownspace.com/fr/privacy-policy",
  TERMS_CONDITIONS_PAGE_URL_EN: "https://ownspace.com/en/terms-and-conditions",
  TERMS_CONDITIONS_PAGE_URL_FR: "https://ownspace.com/fr/termes-et-conditions",
  BUSINESS_PARTNERS_PAGE_URL_EN: "https://ownspace.com/en/business-partners",
  BUSINESS_PARTNERS_PAGE_URL_FR: "https://ownspace.com/fr/business-partners",
}

export const BUYER_REMORSE_PERIOD_DAYS = 1;

export const HOURS_TO_PREPARE_CONTRACT = 48;

export const INVITE_SELLER_FORM_VALUES_STORAGE_KEY = "invite-seller-form-values";
